import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Linkedin } from "lucide-react";
import { ASSETS, PARTNER_TAGS, SOCIALS, LEGAL_LINKS, EARNINGS_DISCLAIMER } from "@/lib/site-data";

const ICONS = { facebook: Facebook, instagram: Instagram, youtube: Youtube, linkedin: Linkedin };

const SiteFooter = () => (
  <footer className="border-t border-white/10 bg-[#0C0C0D] py-14">
    <div className="mx-auto max-w-6xl px-5 sm:px-6 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-10 md:flex-row">
        <div className="max-w-sm">
          <img src={ASSETS.logo} alt="DSA eCommerce" className="h-9 w-auto" />
          <p className="mt-4 text-sm leading-relaxed text-white/55">
            A leading Amazon, Walmart, eBay, Shopify &amp; Temu store-management agency.
            Built for brands. Designed for growth.
          </p>
          {/* social links */}
          <div className="mt-6 flex items-center gap-3" data-testid="social-links">
            {SOCIALS.map((s) => {
              const Icon = ICONS[s.icon];
              return (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  data-testid={`social-${s.icon}`}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-white/70 transition-all duration-300 hover:-translate-y-0.5 hover:border-[#2D5BFF] hover:text-[#2D5BFF]"
                >
                  <Icon className="h-5 w-5" />
                </a>
              );
            })}
          </div>
        </div>

        <div className="flex flex-col gap-8 sm:flex-row sm:gap-16">
          <div>
            <p className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-white/40">
              Legal
            </p>
            <ul className="mt-4 space-y-3">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-legal-${l.to.replace("/", "")}`}
                    className="text-sm text-white/60 transition-colors hover:text-white"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="max-w-xs">
            <p className="font-heading text-xs font-bold uppercase tracking-[0.2em] text-white/40">
              Partner status
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {PARTNER_TAGS.map((t) => (
                <span
                  key={t}
                  className="rounded-full border border-white/10 px-3 py-1.5 font-heading text-[10px] font-bold uppercase tracking-wider text-white/55"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* FTC disclaimer */}
      <p className="mt-12 border-t border-white/10 pt-8 text-xs leading-relaxed text-white/40">
        {EARNINGS_DISCLAIMER} Third-party brand marks and logos shown are the property of
        their respective owners and are used for identification purposes only; their display
        does not imply endorsement.
      </p>

      <div className="mt-6 flex flex-col items-center justify-between gap-4 sm:flex-row">
        <p className="text-xs text-white/40">
          &copy; 2026 DSA eCommerce. All rights reserved.
        </p>
        <div className="flex flex-wrap items-center gap-4">
          {LEGAL_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-xs text-white/40 transition-colors hover:text-white/80"
            >
              {l.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
